export default __webpack_public_path__ + "static/media/welcome.e660e31d.png";